package dev.kuml.portal.web.i18n

/**
 * R-18 §2 -- pure, DOM-free detection of the STARTING language for a visitor who has never made an
 * explicit choice (see [LanguageState.initialise]: a persisted [LanguageStore] value always wins
 * over this). Kept separate from `kotlinx.browser.window.navigator.languages` itself so the
 * decision rule is directly unit-testable under `jsNodeTest` (see `LanguageDetectionTest`) without
 * a browser.
 */
public object LanguageDetection {
    /**
     * @param browserLanguageTags the caller's `navigator.languages` list (or a one-element list
     *   built from `navigator.language`), most-preferred first, exactly as the browser reports it
     *   (e.g. `"de-DE"`, `"en-US"`, `"fr"`).
     * @return [Language.DE] for the first tag whose primary subtag is `"de"`; [Language.EN] for the
     *   first tag whose primary subtag is `"en"` (checked only if no `"de"` tag was found at all);
     *   [Language.EN] as the international-tool-appropriate fallback if neither is present, matching
     *   NEITHER language exactly, INCLUDING an empty list. This is a deliberate change from the
     *   pre-R-18 all-German UI -- see this wave's plan, decision E-2.
     */
    public fun fromBrowserLanguages(browserLanguageTags: List<String>): Language {
        val primaryTags = browserLanguageTags.map { it.substringBefore('-').lowercase() }
        if (primaryTags.any { it == Language.DE.storageValue }) return Language.DE
        if (primaryTags.any { it == Language.EN.storageValue }) return Language.EN
        return Language.EN
    }
}
